import { getTradeTapeItemTime, TradeTapeItem } from '../entities/shared';
import EntityStore from './entity';

const MAX_CLOSED_TRADES = 50;

export default class TradeTapeStore extends EntityStore<TradeTapeItem> {
  constructor() {
    const sortComparer = (tradeA: TradeTapeItem, tradeB: TradeTapeItem) =>
      getTradeTapeItemTime(tradeB) - getTradeTapeItemTime(tradeA);

    super({ sortComparer });
  }

  handleTrade(trade: TradeTapeItem) {
    this.setOne(trade); // Add the new trade

    const trades = this.selectAll(); // Trades sorted by time

    if (trades.length > MAX_CLOSED_TRADES) {
      const tradesToRemove = trades.slice(MAX_CLOSED_TRADES);

      for (const oldTrade of tradesToRemove) {
        this.removeOne(oldTrade.id, { permanent: true });
      }
    }
  }
}
